import { z } from "zod";

export const currencySchema = z.object({
	label: z.string().optional(),
	id: z.number().min(1, "errors.currency_required"),
	value: z.string().optional(),
});

const numericString = (fieldName: string) =>
	z
		.string({
			required_error: `errors.${fieldName.toLowerCase()}_required`,
			invalid_type_error: `errors.${fieldName.toLowerCase()}_must_be_string`,
		})
		.min(1, `errors.${fieldName.toLowerCase()}_required`)
		.refine((val) => /^\d*\.?\d*$/.test(val), `${fieldName.toLowerCase()}_must_be_number`)
		.refine((val) => parseFloat(val) > 0, `${fieldName.toLowerCase()}_must_greater_than_0`);

const ProductSchema = z.object({
	name: z.string().min(3, "errors.name_required"),
	segment: z.number().refine((val) => val > 0, {
		message: "errors.product_segment_required",
	}),
	deliveryType: z.string().min(3, "errors.delivery_type_required"),
	description: z.string().min(5, "errors.description.must_be_least_5").max(250, "errors.description.most_be_least_250"),
	prices: z.array(
		z
			.object({
				currency: z
					.object({
						id: z.number().optional(),
						label: z.string().optional(),
						value: z.string().optional(),
					})
					.optional(),

				amount: numericString("Amount"),
				salary: numericString("Salary"),
				id: z.number().optional(),
			})
			.refine((data) => parseFloat(data.salary) <= parseFloat(data.amount), {
				message: "errors.salary_must_less_equal_amount",
				path: ["salary"],
			})
	),
});

export type FormValues = z.infer<typeof ProductSchema>;

export { ProductSchema };
